import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, RouterLink, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SubscriptionComponent } from '../../../shared/helpers/subscription.component';
import { router } from '../../../shared/shared.global-service';
import { Tab, TabList, Tabs } from '@openng/optimus-ui/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import { featureOn } from '../../../../feature-flag';

type ProfileTab = 'account' | 'preferences' | 'security' | 'msg' | 'wysiwyg' | 'electronic-signature' | 'dashboard';

const tabFromUrl = (url: string): ProfileTab =>
    (url.match(/\/profile\/(account|preferences|security|msg|wysiwyg|electronic-signature|dashboard)/)?.[1] as ProfileTab) ?? 'account';

@Component({
    selector: 'app-profile-page',
    templateUrl: 'profile-page.component.html',
    styleUrl: 'profile-page.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Tabs,
        TabList,
        Tab,
        TranslatePipe,
        RouterLink,
        RouterOutlet,
    ],
})
export class ProfilePageComponent extends SubscriptionComponent {

    protected readonly selectedTab = signal<ProfileTab>(tabFromUrl(router.url));
    protected readonly dashboardSettingsEnabled = featureOn.SOCIAL_SERVICE_DASHBOARD;

    constructor() {
        super();
        this.subs.push(
            router.events
                .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
                .subscribe((e) => this.selectedTab.set(tabFromUrl(e.urlAfterRedirects))),
        );
    }

}
